import { Checkbox, CheckboxProps } from '@mui/material';
import { forwardRef } from 'react';
import React from 'react';

export default forwardRef(
  (props: CheckboxProps, ref: React.Ref<HTMLInputElement>) => {
    const { onChange, name, ...checkboxProps} = props;
    return (
      <Checkbox
        onChange={onChange}
        color="primary"
        inputRef={ref}
        {...checkboxProps}
        data-cy={name ?? ''}
      />
    );
  }
);
